export default class InputError extends Error {
  constructor(message, value, ...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message, value, ...params);

    // Custom debugging information
    this.message = message;
    this.value = value;
  }
}


// WEBPACK FOOTER //
// ./src/shared/errors/InputError.js